import axios from '../config/axios';

const API_BASE = '/vehicles';

const vehicleService = {
  // Get all vehicles with filters
  getAll: (filters = {}) => {
    return axios.get(API_BASE, { params: filters });
  },

  // Get all vehicles with pagination
  getAllVehicles: (page = 1, perPage = 20, filters = {}) => {
    const params = {
      page,
      per_page: perPage,
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get single vehicle
  getVehicle: (vehicleId) => {
    return axios.get(`${API_BASE}/${vehicleId}`);
  },

  // Get vehicle by ID (alias)
  getById: (vehicleId) => {
    return axios.get(`${API_BASE}/${vehicleId}`);
  },

  // Create vehicle
  createVehicle: (data) => {
    // Check if data is FormData
    if (data instanceof FormData) {
      return axios.post(API_BASE, data, {
        headers: {
          'Content-Type': undefined,
        },
      });
    }
    return axios.post(API_BASE, data);
  },

  // Update vehicle
  updateVehicle: (vehicleId, data) => {
    // Check if data is FormData
    if (data instanceof FormData) {
      return axios.put(`${API_BASE}/${vehicleId}`, data, {
        headers: {
          'Content-Type': undefined,
        },
      });
    }
    return axios.put(`${API_BASE}/${vehicleId}`, data);
  },

  // Delete vehicle
  deleteVehicle: (vehicleId) => {
    return axios.delete(`${API_BASE}/${vehicleId}`);
  },

  // Get active vehicles
  getActiveVehicles: () => {
    return axios.get(`${API_BASE}/active`);
  },

  // Get vehicles by type
  getVehiclesByType: (vehicleType) => {
    return axios.get(`${API_BASE}/type/${vehicleType}`);
  },

  // Activate vehicle
  activateVehicle: (vehicleId) => {
    return axios.post(`${API_BASE}/${vehicleId}/activate`);
  },

  // Get vehicle by ID (another alias for consistency)
  getVehicleById: (vehicleId) => {
    return axios.get(`${API_BASE}/${vehicleId}`);
  },

  downloadBulkTemplate: () => {
    return axios.get(`${API_BASE}/bulk-template`, { responseType: 'blob' });
  },

  downloadBulkExport: (companyId = null) => {
    const params = {};
    if (companyId) params.company_id = companyId;
    return axios.get(`${API_BASE}/bulk-export`, { params, responseType: 'blob' });
  },

  uploadBulkExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_BASE}/bulk-import`, formData, {
      headers: { 'Content-Type': undefined },
    });
  },
};

// Export as default
export default vehicleService;